<template>
  <div class="bs-docs-section pt-1 mx-3" id="home">
    <div
      id="carouselExampleCaptions"
      class="carousel slide carousel-fade"
      data-ride="carousel"
    >
      <ol class="carousel-indicators">
        <li
          v-for="(carousel, index) in Finult_Carousel"
          data-target="#carouselExampleCaptions"
          :key="index"
          :class="{ active: index == 0 }"
        ></li>
      </ol>
      <div class="carousel-inner">
        <div
          v-for="(carousel, index) in Finult_Carousel"
          class="carousel-item"
          :key="index"
          :class="{ active: index == 0 }"
        >
          <img
            :src="getImageURL(carousel.carousel_image_url)"
            class="d-block w-100"
            alt=".."
          />
          <div class="carousel-caption ">
            <p class="carousel-yellow-header">{{ carousel.carousel_title }}</p>
            <div class="orange-breaker"></div>
            <h3 class="carousel-header">{{ carousel.carousel_content }}</h3>
          </div>
        </div>
      </div>
      <a
        class="carousel-control-prev"
        href="#carouselExampleCaptions"
        role="button"
        data-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a
        class="carousel-control-next"
        href="#carouselExampleCaptions"
        role="button"
        data-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</template>

<script>
import jsonData from "@/components/json/Finult_Carousel.json";

export default {
  name: "Carousel",
  data() {
    return {
      Finult_Carousel: []
    };
  },
  created() {
    console.log(this.$useFirestore);
    if (this.$useFirestore) {
      this.Finult_Carousel = this.$options.filters.getFireStoreRecords(
        "Finult_Carousel"
      );
    } else {
      this.Finult_Carousel = jsonData.Finult_Carousel;
    }
  },
  methods: {
    getImageURL(imageURL) {
      return imageURL ? require(`../assets/images/${imageURL}`) : "";
    }
  }
};
</script>

<style></style>
